package uz.ferro.erp.locale

import kotlinx.browser.localStorage
import org.w3c.dom.get
import org.w3c.dom.set
import uz.ferro.erp.KEY_LANGUAGE

object LanguageManager {

    var currentLanguage: Language = Language.UZ_LAT
        set(value) {
            field = value
            localStorage[KEY_LANGUAGE] = value.name
        }

    init {
        val lang = localStorage[KEY_LANGUAGE].orEmpty()
        currentLanguage = Language.getByString(lang)
    }
}